import { useState } from 'react';
import getButtonToggle from './components/ButtonToggle';

export default function useToggleWithButton(initialValue?: boolean, ariaControlsId?: string) {
    const [isEnabled, setIsEnabled] = useState(!!initialValue);
    const ButtonToggle = getButtonToggle(isEnabled, setIsEnabled, ariaControlsId);

    return [ButtonToggle, isEnabled, setIsEnabled] as const;
}
